import { render } from "./VideoPropsCmp.vue?vue&type=template&id=15038274"
import script from "./VideoPropsCmp.vue?vue&type=script&lang=js"
export * from "./VideoPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__